<script setup>
import { IMaskComponent } from 'vue-imask';

const props = defineProps({
  name: {
    type: String,
    default: 'name',
  },
  label: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    default: undefined,
  },
  mask: {
    type: String,
    default: undefined,
  },

  theme: {
    type: String,
    default: undefined,
    validator(theme) {
      return ['conference'].includes(theme);
    },
  },
  size: {
    type: String,
    default: undefined,
    validator(size) {
      return ['small'].includes(size);
    },
  },
});

const model = defineModel({ type: String, default: '' });

const { value, errorMessage, handleChange, handleBlur, meta } = useField(
  () => props.name,
  null,
  { initialValue: model.value, validateOnValueUpdate: false },
);

useSyncModels(model, value);

const inputRef = ref(null);
const { focused } = useFocus(inputRef);
</script>

<template>
  <UiFormInputBase
    class="form-input"
    :label="label"
    :is-active="focused"
    :error="errorMessage"
    :theme="theme"
    :size="size"
  >
    <input
      v-if="!mask"
      ref="inputRef"
      v-model.trim="value"
      :type="type"
      :placeholder="placeholder"
      class="form-input__input"
      :class="{ 'form-input__input--error': errorMessage }"
      @input="meta.touched && handleChange($event.target.value.trim())"
      @blur="handleBlur($event, true)"
    />

    <IMaskComponent
      v-else
      ref="inputRef"
      v-model.trim="value"
      :type="type"
      :placeholder="placeholder"
      :mask="mask"
      class="form-input__input"
      :class="{ 'form-input__input--error': errorMessage }"
      @accept:masked="meta.touched && handleChange($event.trim())"
      @blur="handleBlur($event, true)"
    />
  </UiFormInputBase>
</template>

<style scoped lang="scss">
.form-input {
  cursor: text;

  &__input {
    font-size: em(18);
    line-height: em(20, 18);
    color: $color-black;

    @include media-breakpoint-down(sm) {
      font-size: em(16);
      line-height: em(18, 16);
    }

    &::placeholder {
      color: $color-gray-2;
    }

    &--error {
      color: $color-red-1;

      &::placeholder {
        color: $color-red-1;
      }
    }
  }
}
</style>
